import React from 'react';
import styled from 'styled-components';
import { getColorShade } from '../../../../src/styled/utils';
import { cleanSVGProps } from '../utils/svg-cleaner';
function SvgArrowForward(props) {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ...cleanSVGProps(props) },
        React.createElement("path", { d: "M7.665 16.01a.833.833 0 0 0 1.18 0l5.54-5.54c.26-.26.26-.68 0-.94l-5.54-5.54a.833.833 0 0 0-1.18 0 .833.833 0 0 0 0 1.18l4.827 4.833-4.833 4.833c-.32.32-.32.854.006 1.174Z" })));
}
const StyledSvgAccordion = styled(SvgArrowForward) `
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(90deg)' : 'rotate(0deg)')};
  transition: transform 500ms ease-in-out;

  & path {
    fill: ${getColorShade('onSurface', 'mediumEmphasis')};
  }
`;
export default StyledSvgAccordion;
